import React from 'react';
import { BlacklistManager } from '/imports/ui/BlacklistManager';

// The blacklist is a singleton; show the friendly by-username manager instead of
// a list of one doc. The raw JSON editor (BlacklistPage) remains for power users.
export const BlacklistsPage = () => <BlacklistManager />;
